import styled from 'styled-components/macro';

export const RatingListContainer = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`;
